/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Pol_VerifiedInputs */

const en_pol_verified = /** @type {(inputs: Pol_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Checked ${i?.date}`)
};

const id_pol_verified = /** @type {(inputs: Pol_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dicek ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Checked {date}" |
*
* @param {Pol_VerifiedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_verified = /** @type {((inputs: Pol_VerifiedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_VerifiedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_verified(inputs)
	return en_pol_verified(inputs)
});